module.exports = __webpack_public_path__ + "img/vt-twitter.64c94c85.svg";